import { initZoomMotion } from '../../style/motion';
import { genComponentStyleHook, getArrowStyle, mergeToken, PresetColors, resetComponent, } from '../../theme';
const genBaseStyle = token => {
    const { componentCls, popoverBg, popoverColor, width, popoverPaddingHorizontal, popoverTitlePaddingBlockTop, popoverTitlePaddingBlockBottom, lineWidth, lineType, fontWeightStrong, boxShadow, colorSplit, colorTextHeading, radiusBase: borderRadius, paddingSM, zIndexPopup, } = token;
    return [
        {
            [componentCls]: Object.assign(Object.assign({}, resetComponent(token)), { position: 'absolute', top: 0, insetInlineStart: 0, zIndex: zIndexPopup, fontWeight: 'normal', whiteSpace: 'normal', textAlign: 'start', cursor: 'auto', userSelect: 'text', '&-rtl': {
                    direction: 'rtl',
                }, '&-hidden': {
                    display: 'none',
                }, [`${componentCls}-content`]: {
                    position: 'relative',
                }, [`${componentCls}-inner`]: {
                    backgroundColor: popoverBg,
                    backgroundClip: 'padding-box',
                    borderRadius,
                    boxShadow,
                }, [`${componentCls}-title`]: {
                    minWidth: width,
                    margin: 0,
                    padding: `${popoverTitlePaddingBlockTop}px ${popoverPaddingHorizontal}px ${popoverTitlePaddingBlockBottom}px`,
                    color: colorTextHeading,
                    fontWeight: fontWeightStrong,
                    borderBottom: `${lineWidth}px ${lineType} ${colorSplit}`,
                }, [`${componentCls}-inner-content`]: {
                    padding: `${paddingSM}px ${popoverPaddingHorizontal}px`,
                    color: popoverColor,
                } }),
        },
        // Arrow Style
        getArrowStyle(token, token.colorBgElevated),
    ];
};
const genColorStyle = token => {
    const { componentCls } = token;
    return {
        [componentCls]: PresetColors.map((colorKey) => {
            const lightColor = token[`${colorKey}-6`];
            return {
                [`&${componentCls}-${colorKey}`]: {
                    [`${componentCls}-inner`]: {
                        backgroundColor: lightColor,
                    },
                    [`${componentCls}-arrow`]: {
                        background: 'transparent',
                        '&:before': {
                            backgroundColor: lightColor,
                        },
                    },
                },
            };
        }),
    };
};
export default genComponentStyleHook('Popover', token => {
    const { controlHeight, fontSize, lineHeight, lineWidth, colorBgElevated } = token;
    const titlePaddingBlockDist = controlHeight - Math.round(fontSize * lineHeight);
    const popoverToken = mergeToken(token, {
        popoverBg: colorBgElevated,
        popoverColor: token.colorText,
        popoverTitlePaddingBlockTop: titlePaddingBlockDist / 2,
        popoverTitlePaddingBlockBottom: titlePaddingBlockDist / 2 - lineWidth,
        popoverPaddingHorizontal: token.padding,
    });
    return [
        genBaseStyle(popoverToken),
        genColorStyle(popoverToken),
        initZoomMotion(popoverToken, 'zoom-big'),
    ];
}, ({ zIndexPopupBase }) => ({
    zIndexPopup: zIndexPopupBase + 30,
    width: 177,
}));
